
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import Organization from '../../Modals/StateModals/Organization.type'
import { verify } from 'crypto';

interface AuthState {
  org: Organization | null;
  isAuthenticated: boolean;
  
}

const initialState: AuthState = {
  org: null,
  isAuthenticated: false,
};

const authReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<Organization>) => {
      
      state.org = action.payload;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.org = null;
      state.isAuthenticated = false;
    },
    setUser: (state, action: PayloadAction<Organization>) => {
      state.org = { ...state.org, ...action.payload }; // Merge new data with the existing state
    }
  },
});


export const { login, logout, setUser } = authReducer.actions;
export default authReducer.reducer;
